<template>
	<van-swipe class="device-swiper" :autoplay="3000" :show-indicators="true">
	  <van-swipe-item v-for="(device, index) in devicesList" :key="index" @click="toProductinfo(device)">			
         <div class="swiper-item">
            <div class="device-image">
                <van-image
                    width="80"
                    height="80"
                    :src="device.ImageURL"
                    fit="contain"
                    class="device-icon"
                />
            </div>
            <div class="device-info">
                <h3 class="device-model">{{ device.Model || error }}</h3>
                <p class="device-name">{{ device.ProductName || '' }}</p>
                <p class="device-sn">{{ sns }}</p>
            </div>
            <van-icon name="arrow" class="arrow-icon" />
        </div>	 
	  </van-swipe-item>
	</van-swipe>
</template>

<script>
    import Vue from 'vue'
    import global from '../components/global.vue';
	export default {	  
	  name: 'devicecard',
	  props: {
	    msg: String,
        host:String
	  },
	   data() {
	      return {
			 devicesList:[
                {                   
                    ProductName:'等待连接一个打印机',
                    ImageURL:'https://t3.lenovoimage.com//Upload/Products/48002845/48002845_Top_20241012144423.png',
                    Model:''                    
                }               
            ],
            sns:'',
            keyword:'',
            error:''
	      }
	    },
		created(){
            console.log(localStorage['sn'] ,'query')
            var SNs = localStorage['sn']
            if (( SNs != 'undefined') && ( SNs != 'null')) {
                this.sns = SNs
            }
            if (localStorage['model'] != 'undefined') {    
                this.keyword = localStorage['model'] 
            }            
            console.log(this.sns,'sns1')  
            //获取机型数据
            if (this.sns != '' ) {
                this.getproductsInfo()
            }       
		},      	
		methods:{	
            //goto to product info            
            toProductinfo(e){
                 console.log(e,'e')  
                 this.$router.push({ path:'/productinfo?model=' + e.Model  })
            },		
            // 从global变量获取产品信息
            getproductsInfo(){
                console.log('从global变量获取设备列表')
                
                // 检查global.devicesList是否存在且有数据
                if (global.devicesList && global.devicesList.length > 0) {
                    console.log('使用global缓存数据', global.devicesList)
                    this.devicesList = [...global.devicesList]
                    return
                }
                
                // 如果global中没有数据，则从API获取
                console.log('global中无缓存数据，从API获取')
                let that = this                
                Vue.axios.get('https://t3.lenovoimage.com/api/web2/printersinfo?sns=' + this.sns + "&keyword=" + this.keyword)
                    .then(function (res) {
                        console.log(res,'res')
                        if (res.data.Status == '0') {
                            that.devicesList = []
                            that.devicesList = res.data.Data;   
                            global.devicesList = res.data.Data; 
                            console.log(that.devicesList,'deviceList')                         
                        } else {
                            that.devicesList[0].ProductName = '暂时没有匹配到产品信息'
                        }        
                    })
                    .catch(function (error) {
                    console.log(error);
                    });        
            }
		}
	  }
</script>

<style scoped>
.device-swiper {
    margin: 16px;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.swiper-item {
    display: flex;
    align-items: center;
    padding: 20px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border: 1px solid #f0f0f0;
    min-height: 100px;
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;
}

.swiper-item:active {
    background: #f7f8fa;
    transform: scale(0.98);
}

.device-image {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    margin-right: 16px;
    flex-shrink: 0;
}

.device-icon {
    border-radius: 8px;
}

.device-info {
    flex: 1;
    min-width: 0;
    text-align: left;
}

.device-model {
    font-size: 16px;
    font-weight: bold;
    color: #323233;
    margin-bottom: 6px;
    line-height: 1.4;
    word-break: break-all;
}

.device-name {
    font-size: 14px;
    color: #646566;
    margin-bottom: 4px;
    line-height: 1.4;
}

.device-sn {
    font-size: 12px;
    color: #969799;
    margin: 0;
    line-height: 1.4;
}

.arrow-icon {
    color: #969799;
    font-size: 16px;
    margin-left: 12px;
    flex-shrink: 0;
}

/* 轮播指示器样式优化 */
.device-swiper :deep(.van-swipe__indicator) {
    width: 6px;
    height: 6px;
    background-color: #dcdee0;
    opacity: 0.6;
}

.device-swiper :deep(.van-swipe__indicator--active) {
    background-color: #1989fa;
    opacity: 1;
}

/* 空状态样式 */
.swiper-item:only-child .device-model {
    color: #969799;
}

/* 响应式设计 */
@media (max-width: 360px) {
    .device-swiper {
        margin: 12px;
    }
    
    .swiper-item {
        padding: 16px;
        min-height: 100px;
    }
    
    .device-image {
        width: 60px;
        height: 60px;
        margin-right: 12px;
    }
    
    .device-model {
        font-size: 14px;
    }
    
    .device-name {
        font-size: 13px;
    }
}

/* 悬停效果（桌面端） */
@media (hover: hover) {
    .swiper-item:hover {
        background: #f7f8fa;
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
    }
}
</style>